if (!customElements.get('klarna-badge')) {
  customElements.define(
    'klarna-badge',
    class KlarnaBadge extends HTMLElement {
      constructor() {
        super();
        this.onVariantChange = this.onVariantChange.bind(this);
      }

      connectedCallback() {
        try {
          this.sectionId = this.dataset.sectionId;
          this.link = this.querySelector('.klarna-badge');
          this.amount = this.querySelector('.klarna-badge__amount');
          this.variantUnsubscriber =
            typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined'
              ? subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange)
              : null;
          this.closest('product-info')?.addEventListener('variant:changed', this.onVariantChange);
          this.syncFromDom();
        } catch (error) {
          console.error(error);
        }
      }

      disconnectedCallback() {
        this.variantUnsubscriber?.();
        this.closest('product-info')?.removeEventListener('variant:changed', this.onVariantChange);
      }

      onVariantChange(event) {
        const detail = event?.detail || event?.data || event;
        const payload = detail?.data || detail;
        if (payload?.sectionId && payload.sectionId !== this.sectionId) return;
        this.render(payload?.variant);
      }

      syncFromDom() {
        const variantJson = this.closest('product-info')?.querySelector('variant-selects [data-selected-variant]')?.textContent;
        if (!variantJson) return;
        this.render(JSON.parse(variantJson));
      }

      render(variant) {
        if (!variant || !this.link || !this.amount) return;
        const price = Number(variant.price || 0);
        const visible = price > 9900;
        this.link.hidden = !visible;
        if (!visible) return;
        // price is in cents; divide by 36 months → cents/month, ceil to next whole cent, then convert to euros
        const monthly = Math.ceil(price / 36) / 100;
        const formatted = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
          style: 'currency',
          currency: this.dataset.currencyCode || 'EUR',
        }).format(monthly);
        this.amount.textContent = this.dataset.monthlyTemplate.replace('__amount__', formatted);
      }
    }
  );
}
